<template>

    <div class="chart-dog-step-4">

        <b-form-checkbox v-model="docData.showCommentsInReport">
                Show comments in report
        </b-form-checkbox>
        <b-form-textarea v-model="docData.comments">
        </b-form-textarea>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import ChartDogMixin from "@/providers/ChartDogMixin"

    export default Vue.extend({
        name: "ChartDogStep4",
        mixins: [ToolMixin, ChartDogMixin],
    })

</script>


